import { FC, useMemo } from 'react';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import { VSpacingContainer } from '@hh.ru/magritte-ui';

import { useUpdateDraftFilter } from 'src/components/Search/Common/Filters/hooks/draft/useUpdateDraftFilter';
import { sortByOrders } from 'src/components/Search/Common/Filters/hooks/useFilterGroups';
import { toggleValueInArray } from 'src/components/Search/Common/Filters/utils/toggleValueInArray';
import SelectorOption from 'src/components/Search/Resume/Filters/Geo/SelectorOption';
import { useGeoFiltersAnalytics } from 'src/components/Search/Resume/Filters/Geo/hooks/useAnalytics';
import { useSelector } from 'src/hooks/useSelector';
import { EMPTY_CLUSTER } from 'src/models/search/common/clusters';
import { ClusterGroup, ClusterKey } from 'src/types/search/common/clusters';

const EMPTY_ORDERS = [] as const;

interface AreaSelectorProps {
    showSearchItems: boolean;
    searchItems: Array<ClusterGroup>;
}

const AreaSelector: FC<AreaSelectorProps> = ({ showSearchItems, searchItems }) => {
    const updateDraftFilter = useUpdateDraftFilter(ClusterKey.Area);

    const { groups, selectedValues } =
        useSelector((state) => state.searchDraftClusters[ClusterKey.Area]) || EMPTY_CLUSTER;
    const orders = useSelector((state) => state.searchDraftClustersOrder[ClusterKey.Area]) || EMPTY_ORDERS;
    const clusterItems = useMemo(() => sortByOrders(Object.values(groups), orders), [groups, orders]);

    const { sendEventShowAreaFilter } = useGeoFiltersAnalytics();

    return (
        <ElementShownAnchor fn={sendEventShowAreaFilter}>
            <VSpacingContainer default={12}>
                {(showSearchItems ? searchItems : clusterItems).map(({ id, title, count }) => (
                    <SelectorOption
                        key={id}
                        isSelected={selectedValues.includes(Number(id))}
                        onClick={() => updateDraftFilter(toggleValueInArray(Number(id), selectedValues))}
                        text={title}
                        count={count}
                        hideCounter={showSearchItems}
                    />
                ))}
            </VSpacingContainer>
        </ElementShownAnchor>
    );
};

export default AreaSelector;
